import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FadeUp, SectionHead } from "../Reveal";

const FAQS = [
    {
        q: "Vocês atendem empresas?",
        a: "Sim. A IMPRIMA AKI atende empresas, comércios, profissionais e negócios de Campinas e região.",
    },
    {
        q: "Como faço um orçamento?",
        a: "Clique no botão de WhatsApp e envie as informações do material que precisa. Se preferir, preencha nosso formulário de orçamento e continue a conversa pelo WhatsApp com os dados já organizados.",
    },
    {
        q: "Qual o pedido mínimo?",
        a: "O pedido mínimo pode variar conforme o produto. Envie pelo WhatsApp o que você precisa e a quantidade desejada que indicamos a melhor solução.",
    },
    {
        q: "Vocês fazem camisetas personalizadas?",
        a: "Sim, trabalhamos com personalização por sublimação e serigrafia para marcas, equipes, eventos e campanhas.",
    },
    {
        q: "Vocês fazem placas?",
        a: "Sim, trabalhamos com diferentes soluções de placas e comunicação visual, para ambientes internos e externos.",
    },
    {
        q: "Vocês fazem fachadas?",
        a: "Sim, oferecemos soluções de comunicação visual para fachadas comerciais em Campinas e região.",
    },
    {
        q: "Atendem Campinas e região?",
        a: "Sim. Atendemos Campinas e toda a região metropolitana.",
    },
];

export const Faq = () => (
    <section id="faq" data-testid="faq-section" className="bg-paper pb-20 sm:pb-28 lg:pb-32">
        <div className="container-x">
            <div className="grid gap-12 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <SectionHead
                        tag="08 — Dúvidas frequentes"
                        title="Perguntas que respondemos todos os dias."
                        sub="Não achou a sua dúvida? Chame no WhatsApp que respondemos rapidinho."
                    />
                </div>
                <div className="lg:col-span-7">
                    <FadeUp delay={0.1}>
                        <Accordion type="single" collapsible className="w-full space-y-3">
                            {FAQS.map((item, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`faq-${i}`}
                                    data-testid={`faq-item-${i}`}
                                    className="rounded-xl border border-[#E9E9E9] bg-white px-6 transition-colors data-[state=open]:border-brand/40"
                                >
                                    <AccordionTrigger
                                        data-testid={`faq-trigger-${i}`}
                                        className="py-5 text-left font-display text-base font-bold text-ink hover:text-brand hover:no-underline"
                                    >
                                        {item.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="pb-5 text-sm leading-relaxed text-smoke">
                                        {item.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </FadeUp>
                </div>
            </div>
        </div>
    </section>
);
